import React, {ReactElement, useState} from "react";
import {Button, Typography, useTheme} from "@mui/material";
import {DIVIDER, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {gray} from "@/shared/colors";
import {KeyboardDoubleArrowLeftOutlined, KeyboardDoubleArrowRightOutlined} from "@mui/icons-material";

export enum SidebarPosition {
  LEFT,
  RIGHT,
}

export function Sidebar(props: {
  title: string,
  toolbar?: ReactElement,
  children,
  position?: SidebarPosition,
  sidebarCollapsible?: boolean,
}): ReactElement {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
  const theme = useTheme();
  return <div style={{
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    borderRight: props.position === SidebarPosition.LEFT ? DIVIDER : null,
    borderLeft: props.position === SidebarPosition.RIGHT ? DIVIDER : null,
    width: sidebarCollapsed ? PD_SM * 2 + 40 : 300,
    height: "100%",
    overflowY: "scroll",
  }}>
    {!sidebarCollapsed
      ? <><StyledBoxRow
        style={{
          position: "sticky",
          top: 0,
          width: "100%",
          alignItems: "center",
          flexShrink: 0,
          zIndex: 1,
          background: theme.palette.background.paper,
          height: 48,
          borderBottom: DIVIDER,
          padding: `0px ${PD_LG}px`,
        }}>
        <Typography style={{fontWeight: 'bold'}}>
          {props.title}
        </Typography>
        <StyledSpan/>
        {props.toolbar}
      </StyledBoxRow>
        <div style={{display: "flex", flexDirection: "column", padding: PD_LG}}>
          {props.children}
        </div>
      </>
      : null}
    {props.sidebarCollapsible
      ? <Button onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                style={{
                  zIndex: 100,
                  background: gray,
                  color: "black",
                  minWidth: 0,
                  padding: PD_SM,
                  position: 'absolute',
                  left: props.position === SidebarPosition.LEFT ? PD_SM : null,
                  right: props.position === SidebarPosition.RIGHT ? PD_SM : null,
                  bottom: PD_MD,
                }}>
        {sidebarCollapsed
          ? props.position === SidebarPosition.LEFT ? <KeyboardDoubleArrowRightOutlined/> :
            <KeyboardDoubleArrowLeftOutlined/>
          : props.position === SidebarPosition.LEFT ? <KeyboardDoubleArrowLeftOutlined/> :
            <KeyboardDoubleArrowRightOutlined/>}
      </Button>
      : null}
  </div>
}